// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__nA9XN","title":"Hero_title__fKZYR","subtitle":"Hero_subtitle__uDYC8"};